import { render } from "./LanguageSwitcher.vue?vue&type=template&id=81f2de42&scoped=true"
import script from "./LanguageSwitcher.vue?vue&type=script&lang=js"
export * from "./LanguageSwitcher.vue?vue&type=script&lang=js"

import "./LanguageSwitcher.vue?vue&type=style&index=0&id=81f2de42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81f2de42"]])

export default __exports__